import { combineReducers } from 'redux'
import storeDetails from './storeDetails'
import viewDetails from './viewDetails'
import masterSettings from './masterSettings'
import systems from './systems'
import headers from './headers'
import StorePopupDetails from './storePopupReducer'
import users from './users'
import roles from './roles'
import dashboard from './dashboard'
import permissions from './permissions'
import accountinfo from './accountinfo'
import company from './company'
import country from './country'
import brands from './brands'
import userAccounts from './userAccounts'
import devicehistorylist from './devicehistorylist'
import region from './region'
import distributor from './distributor'
import displaysetting from './displaysettings'
import storeRanking from './storeRanking'
import leaderboard from './leaderboard'
import companyLBVersion from './companyLBVersion'
import accountSubscriptionType from './accountSubscriptionType'
import leaderboardGroups from './leaderBoardGroups'
import notification from './notification'

export default combineReducers({
  storeDetails,
  viewDetails,
  StorePopupDetails,
  systems,
  masterSettings,
  headers,
  users,
  roles,
  dashboard,
  permissions,
  accountinfo,
  company,
  country,
  brands,
  userAccounts,
  region,
  distributor,
  displaysetting,
  storeRanking,
  leaderboard,
  devicehistorylist,
  companyLBVersion,
  accountSubscriptionType,
  leaderboardGroups,
  notification
})



// WEBPACK FOOTER //
// ./src/reducers/store/index.js